import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { getStaggerDelay } from './util';

gsap.registerPlugin(ScrollTrigger);

type Instance = {
  trigger: ScrollTrigger;
};

const instances = new WeakMap<HTMLElement, Instance>();
const tweens = new WeakMap<HTMLElement, gsap.core.Tween>();


const setupElement = (element: HTMLElement) => {
  if (element.dataset.animateFadeInSlideUpDone === 'true') {
    return;
  }
  if (element.dataset.animationState === 'animating') {
    return;
  }

  const existing = instances.get(element);
  if (existing) {
    existing.trigger.kill();
  }
  const runningTween = tweens.get(element);
  if (runningTween) {
    runningTween.kill();
    tweens.delete(element);
  }

  // find the closest section ancestor to use as scroll trigger scoping
  const section = element.closest('section') as HTMLElement | null;

  let staggerDelay = 0;

  if( section ) {
    // if there is no section id, assign a unique one
    if( !section.dataset.sectionId ) {
      section.dataset.sectionId = Math.random().toString(36).substr(2, 9);
    } 
    staggerDelay = getStaggerDelay('section-' + section.dataset.sectionId, 0.1, 1500, 0.8);
  } else {
    staggerDelay = getStaggerDelay('global', 0.25, 1500, 0.8);
  }

  let trigger: ScrollTrigger;
  trigger = ScrollTrigger.create({
    trigger: element,
    start: 'top bottom-=100px',
    once: true,
    onEnter: (self) => {
      // const staggerDelay = 0; //getStaggerDelay('global');
      element.dataset.animationState = 'animating';
      const activeTrigger = self;
      const tween = gsap.from(element, {
        y: 40,
        opacity: 0,
        // add a blur filter of 10px that animates to 0px
        duration: 0.6,
        delay: 0 + staggerDelay,
        ease: 'power4.out',
        clearProps: 'transform,opacity',
        onStart: () => {
          
        },
        onComplete: () => {
          element.dataset.animationState = 'done';
          activeTrigger.kill();
          element.dataset.animateFadeInSlideUpDone = 'true';
          instances.delete(element);
          tweens.delete(element);
        }
      });
      tweens.set(element, tween);
    }
  });

  instances.set(element, { trigger });
};

const init = (elements: HTMLElement[]) => {
  elements.forEach((element) => setupElement(element));

};

export default {
  selector: '.box-animation--fade-in-slide-up',
  init
};
